import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';

import Typography from '../../../components/Typography';
import { i18nNS } from '../../../i18n';
import { TileDrawerButton, TileDrawerCheckbox } from '../styles';
import CourseList from './CourseList';
import { Content, tileCoursesFormClasses } from './styles';
import useTileCoursesForm, { UseTileCoursesForm } from './vm';

export interface TileCoursesFormProps extends UseTileCoursesForm {
  className?: string;
}

const TileCoursesForm = ({ className, ...vmProps }: TileCoursesFormProps) => {
  const { t } = useTranslation([i18nNS.SHARED, i18nNS.GLOSSARY]);

  const { isFetchingCourses, courses, formMethods, onSubmit, onClose } = useTileCoursesForm(vmProps);
  const { handleSubmit, control, formState } = formMethods;
  const { isValid, isSubmitting } = formState;

  return (
    <Stack gap={2} component="form" noValidate onSubmit={handleSubmit(onSubmit)} className={className}>
      <Content className={className}>
        <Typography variant="paragraphBold" component="h3">
          {t('select_a_course', { ns: i18nNS.SHARED })}
        </Typography>
        <Typography variant="paragraphRegular">
          {t('in_which_course_will_you_be_using_this_presentation', { ns: i18nNS.SHARED })}
        </Typography>
        <CourseList
          control={control}
          name="selectedCourseId"
          isLoading={isFetchingCourses}
          courses={courses}
          className={tileCoursesFormClasses.courseList}
        />
      </Content>
      <Stack direction="row" justifyContent="space-between" alignItems="center" component="footer">
        <TileDrawerCheckbox
          control={control}
          name="pinSelectedCourse"
          label={t('pin_this_course', { ns: i18nNS.SHARED })}
          disabled={!isValid}
        />
        <Stack direction="row" alignItems="center" gap={2}>
          <TileDrawerButton type="button" variant="text" onClick={onClose}>
            {t('cancel', { ns: i18nNS.GLOSSARY })}
          </TileDrawerButton>
          <TileDrawerButton type="submit" isLoading={isSubmitting} disabled={!isValid || isSubmitting}>
            {t('next', { ns: i18nNS.GLOSSARY })}
          </TileDrawerButton>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default TileCoursesForm;
